import React from 'react';
import useModal from './useModal';
import useOrganizationSearch from './useOrganizationSearch';
import SubGroupItem from './SubGroupItem';
import { useQuery } from '@tanstack/react-query';
import { authHeaders } from 'actions';
import axios from 'axios';
import Routes from 'utils/routes.js.erb';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const SubGroupList = ({group, groupIdx}) => {
  const { t } = useTranslation();
  const { openModal } = useModal();
  const { results } = useOrganizationSearch();
  const { data } = useQuery({
    queryKey: ['administration', 'organization', 'groups', group.id, 'subgroups'],
    queryFn: ({ signal }) => axios.get(
      Routes.api_dashboard_administration_organizations_subgroups_path({group_id: group.id}),
      { headers: authHeaders(), signal }
    ).then(response => response.data),
  })

  return (
    <ul>
      {(results ? (data || []).filter(sg => results.visibleSubgroupIds.has(sg.id)) : (data || [])).map((subgroup, i) => <li key={subgroup.id}><SubGroupItem group={group} groupIdx={groupIdx} subgroup={subgroup} subgroupIdx={i} /></li>)}
      {group.can_add_child && (
        <li className='add level2'>
          <a className='add-button' onClick={() => openModal('subgroup', group)}>
            <i className="fa fa-plus-circle"></i>
            {t('administration.subGroupItem.addSubGroup')}
          </a>
        </li>
      )}
    </ul>
  );
}

SubGroupList.propTypes = {
  group: PropTypes.object.isRequired,
  groupIdx: PropTypes.number.isRequired,
}

export default SubGroupList;
